import { render, staticRenderFns } from "./SubscriptionGrantDialog.vue?vue&type=template&id=0bb1faac&scoped=true"
import script from "./SubscriptionGrantDialog.vue?vue&type=script&lang=js"
export * from "./SubscriptionGrantDialog.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionGrantDialog.vue?vue&type=style&index=0&id=0bb1faac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb1faac",
  null
  
)

export default component.exports